export default {
  "content": "<path d=\"M15.405 15.39a7.841 7.841 0 002.274-5.533c0-4.34-3.51-7.857-7.84-7.857S2 5.518 2 9.857c0 4.34 3.51 7.857 7.84 7.857a7.806 7.806 0 005.565-2.324zm0 0L22 22\" stroke=\"#ff00cb\" stroke-width=\"2\" stroke-linecap=\"round\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};